import {Url} from "./Url.js";

export class LoadMore {
    page;
    url;

    static init(resultCallback, injectDataCallback, page = 2, url = null) {
        let self = new LoadMore();
        self.page = page;
        self.url = url;
        /* for 2 loadmore on page todo pass button container selector */
        $(document).on("click.loadMore", '.loadMore', function () {
            let $button = $(this);
            $button.attr('disabled', true);

            let data = {
                currentPage: self.page
            }

            if (injectDataCallback) {
                data = injectDataCallback(data);
            }

            $.post({
                url: Url.to(self.url || window.location.href) ,
                data: data
            }).done(function (result) {
                self.page = self.page + 1;
                if (result) {
                    resultCallback(result.html, $button);
                    $button.remove();
                }
            });
        });
    }
}